<template>
  <form data-form="autosave account-settings display-theme">
    <h3 data-section-title="form">Display Theme</h3>
    <div data-field="inline-radios">
      <div
        v-for="{ id, label, value } in inputs"
        :key="value"
        class="radio-group"
      >
        <UtilityFormRadio
          v-model="formValue"
          :field-id="id"
          :label="label"
          :value="value"
          name="theme"
          :disabled="disabled"
        />
      </div>
    </div>
    <UtilitySaveIndicator :state="saving" />
  </form>
</template>

<script lang="ts">
import { v4 as uuid } from 'uuid';
import { computed, defineComponent } from 'vue';

import { Theme } from '@/js/api';
import useFormFieldAutoSave from '@/js/composables/useFormFieldAutoSave';
import { useUserStore } from '@/js/stores/user';

export default defineComponent({
  name: 'AccountFormTheme',
  props: {
    disabled: { type: Boolean, default: false },
  },
  setup() {
    const userStore = useUserStore();
    const theme = computed(() => userStore.user?.display_theme ?? Theme.SYSTEM);
    const save = (theme: Theme) => userStore.update({ display_theme: theme });
    const { formValue, saving } = useFormFieldAutoSave({
      value: theme,
      save,
    });
    const inputId = `theme-${uuid()}`;
    const inputs = [
      {
        label: 'System Theme',
        value: Theme.SYSTEM,
        id: `${inputId}-${Theme.SYSTEM}`,
      },
      {
        label: 'Light Mode',
        value: Theme.LIGHT,
        id: `${inputId}-${Theme.LIGHT}`,
      },
      { label: 'Dark Mode', value: Theme.DARK, id: `${inputId}-${Theme.DARK}` },
    ];

    return {
      formValue,
      inputs,
      saving,
      Theme,
    };
  },
});
</script>
